import { Box, Collapse, ListItem, UnorderedList } from '@televet/kibble-ui/build/chakra';
import { Alert } from '@televet/kibble-ui/build/components/Alert';
import { Button } from '@televet/kibble-ui/build/components/Button';
import { Link } from '@televet/kibble-ui/build/components/Link';
import { Text } from '@televet/kibble-ui/build/components/Text';
import React, { useState } from 'react';
import { CareSubscriptionPaymentStatus } from 'shared/types/graphql';
import { centsToDollars, formatCurrency } from '../utils/currency';

interface PastDueInfo {
  totalAmountDue: number;
  totalPaymentsDue: number;
}

export interface MembershipPastDueAlertProps {
  status?: CareSubscriptionPaymentStatus | null;
  pastDueInfo: PastDueInfo;
  openBillingPortal: () => void;
}

interface DescriptionProps extends PastDueInfo {
  openBillingPortal: () => void;
}

const Description = ({ totalAmountDue, totalPaymentsDue, openBillingPortal }: DescriptionProps): JSX.Element => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  return (
    <Box>
      <Collapse in={!isCollapsed}>
        <UnorderedList pl={1}>
          <ListItem>
            <Text size="sm">
              Total Amount:{' '}
              <Text size="sm" fontWeight="bold">
                {formatCurrency(centsToDollars(totalAmountDue), true)}
              </Text>
            </Text>
          </ListItem>
          <ListItem>
            <Text size="sm">
              Total Payments:{' '}
              <Text size="sm" fontWeight="bold">
                {totalPaymentsDue}
              </Text>
            </Text>
          </ListItem>
        </UnorderedList>
        <Text as="p" size="sm">
          <Link
            onClick={openBillingPortal}
            variant="default"
            size="sm"
            iconProps={{
              name: 'externalLink',
              size: 'sm',
              position: 'end',
            }}
          >
            Update billing information
          </Link>{' '}
          and pay past due balance before using benefits.
        </Text>
      </Collapse>
      <Button onClick={(): void => setIsCollapsed((prevState) => !prevState)} variant="secondary" size="xs" mt={1}>
        {isCollapsed ? 'Show' : 'Hide'} Details
      </Button>
    </Box>
  );
};

export const MembershipPastDueAlert = ({
  status,
  pastDueInfo,
  openBillingPortal,
}: MembershipPastDueAlertProps): JSX.Element | null => {
  if (status !== CareSubscriptionPaymentStatus.PastDue) {
    return null;
  }
  return (
    <Alert
      title="Membership Past Due"
      status="error"
      description={
        <Description
          totalAmountDue={pastDueInfo.totalAmountDue}
          totalPaymentsDue={pastDueInfo.totalPaymentsDue}
          openBillingPortal={openBillingPortal}
        />
      }
      titleProps={{
        fontSize: '16px',
      }}
      hideCloseButton
      mt={2}
    />
  );
};
